"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _callout = _interopRequireDefault(require("../../factories/callout"));
var _link = _interopRequireDefault(require("../../factories/link"));
var _embed = _interopRequireDefault(require("../../factories/embed"));
var _syntheticLink = _interopRequireDefault(require("../../factories/synthetic-link"));
var _personSnippet = _interopRequireDefault(require("../../factories/person-snippet"));
var _multiBrandLink = _interopRequireDefault(require("../../factories/multi-brand-link"));
var _team = _interopRequireDefault(require("../../factories/team"));
var _replacementToken = _interopRequireDefault(require("../../factories/replacement-token"));
var _contentImage = _interopRequireDefault(require("../../factories/content-image"));
var _resultsButton = _interopRequireDefault(require("../../factories/results-button"));
var _pill = _interopRequireDefault(require("../../factories/pill"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _default = {
  callout: _callout["default"],
  contentImage: _contentImage["default"],
  contentLink: _link["default"],
  embed: _embed["default"],
  page: _syntheticLink["default"],
  page_v2: _syntheticLink["default"],
  productPage: _syntheticLink["default"],
  helpPost: _syntheticLink["default"],
  journey: _syntheticLink["default"],
  topicPage: _syntheticLink["default"],
  multiBrandLink: _multiBrandLink["default"],
  personSnippet: _personSnippet["default"],
  team: _team["default"],
  replacementToken: _replacementToken["default"],
  resultsButton: _resultsButton["default"],
  pill: _pill["default"]
};
exports["default"] = _default;